import {
  EV_EXISTING_PATHS,
  EV_EXISTING_ROUTES,
} from "src/consts/Routes/EvExisting";
import { lazy, Suspense, useContext } from "react";
import BackButton from "src/components/Shared/BackButton";
import FooterLinks from "src/components/Footer/FooterLinks";
import { ThemeValues } from "src/components/ThemeUsage/theme";
import { Container, Grid, Stack, useTheme } from "@mui/material";
import { ThemeContext } from "src/components/ThemeUsage/ThemeUsage";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import EvExistingProgressBar from "src/components/ProgressBar/MicroFrontend/EvExisting";

const Terms = lazy(() => import("src/pages/EvExisting/Terms"));
const Transfer = lazy(() => import("src/pages/EvExisting/Transfer"));
const Compatibility = lazy(() => import("src/pages/EvExisting/Compatibility"));

const EvExistingContainer = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const themeName = useContext(ThemeContext);
  const isUserSelectEnabled = themeName !== ThemeValues.lichtblick;

  const showBackBtn =
    pathname === EV_EXISTING_PATHS.COMPATIBILITY ||
    pathname === EV_EXISTING_PATHS.TERMS
      ? true
      : false;

  return (
    <Stack
      sx={{
        minHeight: "100vh",
        background: theme.palette.background.default,
        userSelect: isUserSelectEnabled ? undefined : "none",
      }}
    >
      <Container
        sx={{
          p: 4,
          flexGrow: 1,
          marginTop: { xs: 0, sm: 12 },
        }}
      >
        <Grid container>
          <Grid item xs={12} sm={4}>
            <Stack gap="50px">
              {EV_EXISTING_ROUTES.includes(pathname) && (
                <EvExistingProgressBar />
              )}
            </Stack>
          </Grid>

          {showBackBtn && (
            <BackButton
              variant={
                themeName === ThemeValues.lichtblick ||
                themeName === ThemeValues.SMA
                  ? "dark"
                  : "light"
              }
              onClick={() => navigate(-1)}
              sx={(theme) => ({
                backgroundColor: theme.palette.background.default,
                "&:hover": {
                  backgroundColor: theme.palette.background.default,
                },
                display: { xs: "flex", sm: "none" },
              })}
            />
          )}

          <Grid item xs={12} sm={8} sx={{ paddingLeft: { sm: 5, md: 20 } }}>
            <Routes>
              <Route
                element={
                  <Suspense fallback={<div />}>
                    <Transfer />
                  </Suspense>
                }
                path={EV_EXISTING_PATHS.TRANSFER}
              />
              <Route
                element={
                  <Suspense fallback={<div />}>
                    <Compatibility />
                  </Suspense>
                }
                path={EV_EXISTING_PATHS.COMPATIBILITY}
              />
              <Route
                element={
                  <Suspense fallback={<div />}>
                    <Terms />
                  </Suspense>
                }
                path={EV_EXISTING_PATHS.TERMS}
              />
            </Routes>
          </Grid>
        </Grid>
      </Container>
      <FooterLinks />
    </Stack>
  );
};

export default EvExistingContainer;
